import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// --- Component ---
import { AppComponent } from './app.component';

const routes: Routes = [
	{
		path: '',
		component: AppComponent,
		loadChildren: () => import('@pages/pages.module').then(m => m.PagesModule),
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			anchorScrolling: 'enabled',
			scrollPositionRestoration: 'enabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
